export const AUTH_ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  REGISTER_VERIFY_OTP: '/register/otp/verify',
  OTP: '/otp',
  DASHBOARD: '/dashboard',
} as const;
